import { createRouter, createWebHistory } from 'vue-router';

import Cookies from 'js-cookie';
import store from '../store/index';

import BaseLayout from '../views/BaseLayout.vue';
import NotFound from '@/views/NotFound';
import Maintenance from '@/views/Maintenance';
import NewTDA from '@/views/NewTDA.vue';

import Configure from '../views/steps/Configure.vue';
import Participants from '../views/steps/Participants.vue';
import AddParticipant from '../views/steps/AddParticipant.vue';
import CreateNewParticipant from '../views/steps/CreateNewParticipant.vue';
import Tariffs from '../views/steps/Tariffs.vue';
import Periods from '../views/steps/Periods.vue';
import NewTDATariffs from '../views/steps/NewTDATariffs.vue';
import NewTDATariffsSubscription from '../views/steps/NewTDATariffsSubscription.vue';
import NewTDAParticipantSubscription from '../views/steps/NewTDAParticipantSubscription.vue';
import NewTDAParticipants from '../views/steps/NewTDAParticipants.vue';
import NewTDASessions from '../views/steps/NewTDASessions.vue';
import Documents from '../views/steps/Documents.vue';
import Options from '../views/steps/Options.vue';
import EscapeOptions from '../views/steps/EscapeOptions.vue';
import CartRecap from '../views/steps/CartRecap.vue';
import NewTDACartRecap from '../views/steps/NewTDACartRecap.vue';
import Calendar from '../views/steps/Calendar.vue';
import Session from '../views/steps/Session.vue';
import Products from '../views/steps/Products.vue';
import Terrain from '../views/steps/Terrain.vue';
import OfferList from '../views/steps/OfferList.vue';
import Confirmation from '../views/steps/Confirmation.vue';
import ResumeOrder from '../views/steps/ResumeOrder.vue';

// courts
import CourtReservation from '../views/steps/CourtReservation.vue';
import CourtProducts from '../views/steps/court/CourtProducts.vue';
import CourtSessions from '../views/steps/court/CourtSessions.vue';
import CourtParticipants from '../views/steps/court/CourtParticipants.vue';
import CourtOptions from '../views/steps/court/CourtOptions.vue';
import CourtPayment from '../views/steps/court/CourtPayment.vue';
import CourtConfirmation from '../views/steps/court/CourtConfirmation.vue';
import CourtSessionUnavailable from '../views/steps/court/CourtSessionUnavailable.vue';
import CourtSessionUnpaidOrder from '../views/steps/court/CourtSessionUnpaidOrder.vue';

import { isImpersonateMode } from '@/utils/requests';

import { setGTMDataLayer, setGTMInfo, computeProductArrayByCart } from '../utils/index';

import { computeFunnelType } from '@/utils/utils';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: BaseLayout,
    children: [
      {
        name: 'ResumeOrder',
        path: 'reprendre-commande',
        component: ResumeOrder,
        meta: {}
      },
      {
        name: 'Configure',
        path: 'participants', // Set basic information about the users and options
        component: Configure,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix du produit',
          checkoutStepNumber: 1,
          sendGtmInfoFirst: true,
          gtmEvents: [
            { event: 'ecommerceNEO', eventCommand: 'cartProductAdded', productArray: [] }
          ]
        }
      },
      {
        name: 'Participants',
        path: 'nbr-participants', // Select the participants
        component: Participants
      },
      {
        name: 'AddParticipant',
        path: 'ajouter-participant', // Add a new participant
        component: AddParticipant,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix du participant',
          checkoutStepNumber: 2
        }
      },
      {
        name: 'CreateNewParticipant',
        path: 'creer-participant', // Add a new participant
        component: CreateNewParticipant,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'création du participant',
          checkoutStepNumber: 3
        }
      },
      {
        name: 'Periods',
        path: 'period',
        component: Periods
      },
      {
        name: 'Tariffs',
        path: 'tarif', // Select the tariff
        component: Tariffs,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix du tarif',
          checkoutStepNumber: 4
        }
      },
      {
        name: 'Documents',
        path: 'documents', // Upload required documents
        component: Documents,
        meta: {}
      },
      {
        name: 'Options',
        path: 'option', // Select options
        component: Options,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix des options',
          ignoreGtm: true,
          gtmEvents: [
            { event: 'ecommerceNEO', eventCommand: 'checkoutStep', checkoutStepNumber: 5, checkoutStepName: 'choix des options', productArray: [] }
          ]
        }
      },
      {
        name: 'EscapeOptions',
        path: 'escape-option', // Select options
        component: EscapeOptions,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix des options',
          ignoreGtm: true,
          gtmEvents: [
            { event: 'ecommerceNEO', eventCommand: 'checkoutStep', checkoutStepNumber: 5, checkoutStepName: 'choix des options', productArray: [] }
          ]
        }
      },
      {
        name: 'Calendar',
        path: 'calendrier', // Select day
        component: Calendar,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix du créneau horaire',
          checkoutStepNumber: 6
        }
      },
      {
        name: 'Session',
        path: 'seance', // Select session
        component: Session
      },
      {
        name: 'Products',
        path: 'products', // Select session
        component: Products,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix des produit',
          ignoreGtm: true,
          gtmEvents: [
            { event: 'ecommerceNEO', checkoutStepName: 'choix des produit', eventCommand: 'slotSelected', productArray: [] }
          ]
        }
      },
      {
        name: 'Terrain',
        path: 'terrain', // Select session
        component: Terrain,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix du terrain',
          checkoutStepNumber: 1
        }
      },
      {
        name: 'OfferList',
        path: 'offer-list',
        component: OfferList,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'choix de offer',
          checkoutStepNumber: 1
        }
      },
      {
        name: 'CartRecap',
        path: 'recapitulatif', // Show cart details
        component: CartRecap,
        meta: {
          gtmInfo: true,
          checkoutStepName: 'récapitulatif avant paiement',
          ignoreGtm: true,
          gtmEvents: [
            { event: 'ecommerceNEO', eventCommand: 'checkoutStep', checkoutStepNumber: 7, checkoutStepName: 'récapitulatif avant paiement', productArray: [] }
          ]
        }
      },
      {
        name: 'NewTDA',
        path: 'single-unit',
        component: NewTDA,
        children: [
          {
            name: 'NewTDAParticipants',
            path: 'participant', // Select the tariff
            component: NewTDAParticipants,
            meta: { type: 'participant' }
          },
          {
            name: 'NewTDATariffs',
            path: 'tarif', // Select the tariff
            component: NewTDATariffs,
            meta: {
              type: 'tariffs',
              gtmInfo: true,
              checkoutStepName: 'Choisissez vos tarifs',
              checkoutStepNumber: 1,
              sendGtmInfoFirst: true,
              gtmEvents: [
                { event: 'ecommerceNEO', eventCommand: 'cartProductAdded', productArray: [] }
              ]
            }
          },
          {
            name: 'NewTDASessions',
            path: 'sessions', // Select the session
            component: NewTDASessions,
            meta: { type: 'sessions' }
          },
          {
            name: 'NewTDACartRecap',
            path: 'recapitulatif', // Show cart details
            component: NewTDACartRecap,
            meta: {
              type: 'recap',
              gtmInfo: true,
              checkoutStepName: 'Récapitulatif & Paiement',
              ignoreGtm: true,
              gtmEvents: [
                {
                  event: 'ecommerceNEO',
                  eventCommand: 'checkoutStep',
                  checkoutStepNumber: 2,
                  checkoutStepName: 'récapitulatif avant paiement',
                  productArray: []
                }
              ]
            }
          }
        ]
      },
      {
        name: 'NewTDARecurring',
        path: 'abonnement',
        component: NewTDA,
        meta: {
          gtmInfo: true,
          ignoreGtm: true,
          gtmEvents: [
            {
              event: 'ecommerceNEO',
              eventCommand: 'cartProductAdded',
              productArray: []
            }
          ]
        },
        children: [
          {
            name: 'NewTDATariffsSubscription',
            path: 'tarif',
            component: NewTDATariffsSubscription,
            meta: {
              type: 'tariffs',
              gtmInfo: true,
              ignoreGtm: true,
              gtmEvents: [
                {
                  event: 'ecommerceNEO',
                  eventCommand: 'checkoutStep',
                  checkoutStepName: 'choix du tarif',
                  checkoutStepNumber: 1,
                  checkoutStepActive: 'oui'
                }
              ]
            }
          },
          {
            name: 'NewTDAParticipantSubscription',
            path: 'information',
            component: NewTDAParticipantSubscription,
            meta: {
              type: 'participantSubscription',
              gtmInfo: true,
              ignoreGtm: true
            }
          },
          {
            name: 'NewTDACartRecapRecurring',
            path: 'recap',
            component: NewTDACartRecap,
            meta: {
              type: 'recap',
              gtmInfo: true,
              ignoreGtm: true,
              gtmEvents: [
                {
                  event: 'ecommerceNEO',
                  eventCommand: 'checkoutStep',
                  checkoutStepName: 'récapitulatif avant paiement',
                  checkoutStepNumber: 7,
                  checkoutStepActive: 'oui',
                  productArray: []
                }
              ]
            }
          }
        ]
      },
      {
        name: 'CourtReservation',
        path: 'reservation-terrain',
        component: CourtReservation,
        meta: {
          gtmInfo: true,
          ignoreGtm: true,
          gtmEvents: []
        },
        children: [
          {
            name: 'CourtSessionUnavailable',
            path: 'unavailable',
            component: CourtSessionUnavailable,
            meta: { }
          },
          {
            name: 'CourtSessionUnpaid',
            path: 'unpaid',
            component: CourtSessionUnpaidOrder,
            meta: { }
          },
          {
            name: 'CourtProducts',
            path: 'produits',
            component: CourtProducts,
            meta: { title: 'choisissez un produit' }
          },
          {
            name: 'CourtSessions',
            path: 'sessions',
            component: CourtSessions,
            meta: { title: 'Mon terrain' }
          },
          {
            name: 'CourtParticipants',
            path: 'participants',
            component: CourtParticipants,
            meta: { title: 'Ma participation' }
          },
          {
            name: 'CourtOptions',
            path: 'option',
            component: CourtOptions,
            meta: { title: 'Mes options' }
          },
          {
            name: 'CourtPayment',
            path: 'payment',
            component: CourtPayment,
            meta: { title: 'Mon moyen de paiement' }
          },
          {
            name: 'CourtConfirmation',
            path: 'confirmation',
            component: CourtConfirmation,
            meta: { title: `Confirmation de ta ${store.state.courtSettings.isInvite ? 'participation' : 'réservation'}` }
          }
        ]
      },
      {
        name: 'CoupeFileTDA',
        path: 'coupe-file',
        component: () => import('@/views/steps/CoupeFileTDA.vue'),
        meta: {
          type: 'coupeFile',
          gtmInfo: true,
          checkoutStepName: 'coupe file tda',
          checkoutStepNumber: 1
        }
      },
      {
        name: 'CoupeFileConfirmation',
        path: 'coupe-file-confirmation',
        component: () => import('@/views/steps/CoupeFileConfirmation.vue'),
        meta: {
          type: 'coupeFile',
          gtmInfo: true,
          checkoutStepName: 'confirmation coupe file',
          checkoutStepNumber: 2
        }
      },
      {
        name: 'Confirmation',
        path: 'confirmation',
        component: Confirmation,
        meta: {
          ignoreGtm: true,
          gtmInfo: true
        }
      },
      {
        name: 'Maintenance',
        path: 'maintenance',
        component: Maintenance
      },
      {
        name: 'Catcher',
        path: '404',
        component: NotFound
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'Catcher' }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  // Route flow control
  if (['Home', 'Catcher', 'CartRecap', 'Confirmation', 'Maintenance', 'Products', 'NewTDA', 'NewTDARecurring', 'CourtReservation', 'CourtSessionUnavailable', 'CoupeFileTDA', 'CoupeFileConfirmation'].includes(to.name)) return next();

  if ((!process.env.VUE_APP_DEV || process.env.VUE_APP_DEV === 'false') && store.state.flow !== to.name && !store.state.backNavigation) {
    return next({ name: store.state.flow });
  }

  if (store.state.impersonateData) {
    const impersonateResponse = await isImpersonateMode();

    if (impersonateResponse.success) {
      store.commit('setImpersonateCollaborator', impersonateResponse.data.collaborator_uuid);
    }

    if (!impersonateResponse.success) {
      store.commit('setImpersonateData', null);
      store.commit('setImpersonateCollaborator', null);

      if (store.getters.siteURL) {
        window.location.href = store.getters.siteURL;
        return undefined;
      }
    }
  }

  return next();
});

router.afterEach(to => {
  try {
    if (store.state.newTDA) {
      store.commit('addVisitedStep', to.name);
    }

    // Send GTM info in every route change
    if (!['Home', 'Maintenance'/* , 'Products' */].includes(to.name)) {
      const { product } = store.state;
      const { offerInfo } = store.state;
      const productArray = computeProductArrayByCart(store.state.cartItem, product, offerInfo, store.state.siteInfo);
      let dataLayerToPush = null;

      // send always
      const cookie = Cookies.get('id_token');
      setGTMDataLayer(store.state.siteInfo, cookie, store.state.user, to.path, computeFunnelType(), store.state.impersonateData);

      /* DataLayer that doesn't use the router */
      if (to.meta.type === 'participantSubscription') {
        return;
      }

      if (to.meta.gtmEvents) {
        to.meta.gtmEvents.map(event => {
          let dataLayer = { ...event, tunnelType: computeFunnelType() };

          if (event.productArray) {
            dataLayer = {
              ...dataLayer,
              ...computeProductArrayByCart(store.state.cartItem, product, offerInfo, store.state.siteInfo)
            };
          }
          dataLayerToPush = dataLayer;

          return event;
        });
      }

      if (to.meta.gtmInfo && !to.meta.ignoreGtm) {
        to.meta.checkoutStepActive = 'oui';
        if (to.meta.sendGtmInfoFirst && dataLayerToPush) {
          window.dataLayer.push(dataLayerToPush);
        }
        setGTMInfo(to, productArray);
      }

      if (!to.meta.sendGtmInfoFirst && dataLayerToPush) {
        window.dataLayer.push(dataLayerToPush);
      }
    }
  } catch (err) {
    console.log(`Error populating GTM info: ${err}`);
  }
});

export default router;
